export default __webpack_public_path__ + "static/media/080_finish_bad.hevc.cfae8d08.mp4";